import React, {useState, useEffect, forwardRef} from 'react';
import {useDispatch} from 'react-redux';
import PropTypes from 'prop-types';
import {checkAndSetSelectedTipChannelByCardId, insertTask} from 'stores/business/taskListBusinessAction';

import withIntl from '../../../../../../lib/withIntl';

import './InsertTaskButton.scss';

const InsertTaskButton = forwardRef(({number, isInsertTaskShown, cardId, onSelectTask, isCardInvalid, intl}, ref) => {
  const dispatch = useDispatch();
  const [hover, setHover] = useState(false);

  function onMouseEnterHandler() {
    if (!isInsertTaskShown) {
      setHover(true);
    }
  }

  function onMouseLeaveHandler() {
    setHover(false);
  }

  async function onInsertTask() {
    onSelectTask(null);
    await dispatch(insertTask(cardId, number));
    dispatch(checkAndSetSelectedTipChannelByCardId(cardId, true));
  }

  useEffect(() => {
    if (!isInsertTaskShown) {
      setHover(false);
    }
  }, [isInsertTaskShown]);
  return (
    <div
      ref={ref}
      className={`add-task-button ${hover && !isInsertTaskShown && 'active'}`}
      onMouseEnter={onMouseEnterHandler}
      onMouseLeave={onMouseLeaveHandler}
    >
      {!isInsertTaskShown && hover && (
        <div
          className={`add-task-button-content ${hover && !isInsertTaskShown && 'active'} ${isCardInvalid && 'invalid'}`}
          onClick={(e) => {
            onInsertTask();
            e.stopPropagation();
          }}
          role="presentation"
        >
          <span className="icon-plus" />
          <span className="text">{intl.formatMessage({id: 'protocolEditor.taskList.insertTask'})}</span>
        </div>
      )}
    </div>
  );
});

InsertTaskButton.propTypes = {
  number: PropTypes.number.isRequired,
  cardId: PropTypes.string.isRequired,
  isInsertTaskShown: PropTypes.bool.isRequired,
  isCardInvalid: PropTypes.bool.isRequired,
  onSelectTask: PropTypes.func.isRequired,
  intl: PropTypes.any.isRequired,
};

export default withIntl(InsertTaskButton);
